<template>

    <main class="gmp-page gmp-page--no-newsletter">
        <FS_subpagehero />
        <FS_two_column_text />
        <FS_two_column_fullbleed />

    </main>

</template>


<script>
    import FS_subpagehero from "../../../components/content/enterprise/benefit/FS_subpagehero";
    import FS_two_column_text from "../../../components/content/enterprise/benefit/FS_two_column_text";
    import FS_two_column_fullbleed from "../../../components/content/enterprise/benefit/FS_two_column_fullbleed";


    export default {
        name: 'FS_Benefit',
        components:{
            FS_subpagehero,
            FS_two_column_text,
            FS_two_column_fullbleed,

        }

    }


</script>

<style>



</style>